import { defineMessages } from 'react-intl';

export default defineMessages({
    PaymentPageTitle: {
        id: 'cep.components.SgRenewalPaymentPage.PaymentPageTitle',
        defaultMessage: 'Payment page'
    },
    DifferentPaymentOption: {
        id: 'cep.components.SgRenewalPaymentPage.DifferentPaymentOption',
        defaultMessage: 'If you would like to discuss different payment options, please call us on {phoneNumber}.'
    },
    CostToPay: {
        id: 'cep.components.SgRenewalPaymentPage.CostToPay',
        defaultMessage: 'Cost to pay'
    },
    CurrentDetails: {
        id: 'cep.components.SgRenewalPaymentPage.CurrentDetails',
        defaultMessage: 'Your current payment details'
    },
    ContinueCardPayment: {
        id: 'cep.components.SgRenewalPaymentPage.ContinueCardPayment',
        defaultMessage: 'Continue to card payment'
    },
    UpdateDetails: {
        id: 'cep.components.SgRenewalPaymentPage.UpdateDetails',
        defaultMessage: 'Update your payment details'
    },
    RequireImmediatePayment: {
        id: 'cep.components.SgRenewalPaymentPage.RequireImmediatePayment',
        defaultMessage: 'Clicking on Pay now below will make a one-off card payment for your insurance policy'
    },
    Cancel: {
        id: 'cep.components.SgRenewalPaymentPage.Cancel',
        defaultMessage: 'Cancel'
    },
    CancelUpdating: {
        id: 'cep.components.SgRenewalPaymentPage.CancelUpdating',
        defaultMessage: 'Back to my current details'
    },
    ChangePayment: {
        id: 'cep.components.SgRenewalPaymentPage.ChangePayment',
        defaultMessage: 'Change my payment details'
    },
    NewCard: {
        id: 'cep.components.SgRenewalPaymentPage.NewCard',
        defaultMessage: 'Use different card details'
    },
    Purchase: {
        id: 'cep.components.SgRenewalPaymentPage.Purchase',
        defaultMessage: 'Pay now'
    },
    Confirm: {
        id: 'cep.components.SgRenewalPaymentPage.Confirm',
        defaultMessage: 'Confirm'
    }
});
